<ui-grid [data]="data$ | async"
          [loading]="loading$ | async"
          [selectable]="false">
    <ui-grid-column [sortable]="false"
                    [title]="'transactions_details_history_grid_action' | translate"
                    property="action"
                    minWidth="5"
                    width="15%">
        <ng-template let-entry="data">
            <ng-container *ngLet="('TransactionAction_' + entry.action | translate) as actionText">
                <span [matTooltip]="actionText">
                    {{ actionText }}
                </span>
            </ng-container>
        </ng-template>
    </ui-grid-column>
    <ui-grid-column [sortable]="false"
                    [title]="'transactions_details_history_grid_who' | translate"
                    property="userName"
                    width="15%">
    </ui-grid-column>
    <ui-grid-column [sortable]="false"
                    [title]="'transactions_details_history_grid_status' | translate"
                    property="status"
                    width="15%">
        <ng-template let-entry="data">
            <ng-container *ngLet="('TransactionStatus_' + entry.status | translate) as statusText">
                <span [matTooltip]="statusText">
                    {{ statusText }}
                </span>
            </ng-container>
        </ng-template>
    </ui-grid-column>
    <ui-grid-column [sortable]="false"
                    [title]="'transactions_details_history_grid_review' | translate"
                    property="reviewStatus"
                    width="15%">
        <ng-template let-entry="data">
            <ng-container *ngLet="('ReviewStatus_' + entry.reviewStatus | translate) as reviewStatusText">
                <span [matTooltip]="reviewStatusText">
                    {{ reviewStatusText }}
                </span>
            </ng-container>
        </ng-template>
    </ui-grid-column>
    <ui-grid-column [sortable]="false"
                    [title]="'transactions_details_history_grid_reviewer' | translate"
                    property="reviewerUserName"
                    width="20%">
    </ui-grid-column>
    <ui-grid-column [sortable]="true"
                    [title]="'transactions_details_history_grid_time' | translate"
                    property="timestamp"
                    sort="asc"
                    width="20%">
        <ng-template let-index="index"
                     let-entry="data">
            <ui-dateformat #timestampFormat
                           [matTooltip]="timestampFormat?.dataset['title']"
                           [date]="entry.timestamp"
                           contentType="relative"></ui-dateformat>
        </ng-template>
    </ui-grid-column>
    <ui-grid-footer [length]="total$ | async"
                    [pageSize]="pageSize"
                    [pageSizes]="pageSizes">
    </ui-grid-footer>
</ui-grid>
